import debounce from '../../utils/debounce';

class ValuationRangeExternal extends HTMLElement {
  constructor() {
    super();
    this.attachShadow({ mode: 'open' });
    this.iframe = document.createElement('iframe');
    this.iframe.style.width = '100%';
    this.iframe.style.border = 0;
    this.processAttributesDebounced = debounce(this.processAttributes, 1);
  }

  static get observedAttributes() {
    return ['embed', 'layout', 'breakpoint', 'banner-type', 'partner'];
  }

  processAttributes() {
    const url = new URL(process.env.VUE_APP_IFRAME_URL, window.location.href);
    const searchParams = {
      embed: this.getAttribute('embed') === 'sla' ? 'sla' : 'funnel',
      layout: this.getAttribute('layout'),
      breakpoint: this.getAttribute('breakpoint'),
      'banner-type': this.getAttribute('banner-type'),
      platform: 'immowelt',
      source: 'IFRAME_EF',
      partner: this.getAttribute('partner'),
    };
    Object.entries(searchParams).forEach(([key, value]) => {
      if (value !== null && value !== undefined) {
        url.searchParams.set(key, value);
      }
    });

    if (this.iframe.src !== url.toString()) {
      this.iframe.src = url;
    }

    if (!this.shadowRoot.firstChild) {
      const style = document.createElement('style');
      style.textContent = ':host { display: block; }';
      this.shadowRoot.appendChild(style);
      this.shadowRoot.appendChild(this.iframe);
    }
  }

  connectedCallback() {
    if (this.shadowRoot.firstChild) {
      return; // this web component instance has already been set up
    }
    window.addEventListener('message', event => {
      const iframeOrigin = new URL(this.iframe.src).origin;
      if (iframeOrigin === event.origin) {
        this.iframe.style.height = `${event.data.height}px`;
      }
    });
    this.processAttributesDebounced();
  }

  attributeChangedCallback() {
    this.processAttributesDebounced();
  }
}

customElements.define('valuation-range-external', ValuationRangeExternal);
